import { Space, Button, message, Tag, Dropdown, Menu, Badge } from 'antd';
import { useMemo } from 'react';

import { useAccess } from 'umi';
import { DownOutlined } from '@ant-design/icons';

export type QAItem = {
  id: number;
  productName: string;
  productZhName: string;
  question: string;
  answer: string;
  version: number;
  setMaker: boolean;
  permit: boolean;
  tags: string[] | null;
  createdAt: string;
  verifiedName?: string;
  creator: { name: string };
  teamWorker: { name: string };
  isPreAudit: boolean;
  preAuditComment?: string;
  verifiedStatus: string;
  verifiedComment?: string;
  trigger?: string;
  remark?: string;
  judgement: number;
  isFirstOfItsKind?: boolean;
  dataBefore?: string;
  prompt?: string;
  thinking?: string;
};

export type QAUpdateProp = {
  id: number;
  data: {
    answer?: string;
    question?: string;
  };
};

export const TagEditComponent: React.FC<{
  tags: string[];
  permit: boolean;
  id: number;
  handleTag: (data: PgTagItem) => void;
}> = ({ tags, permit, id, handleTag }) => {
  const access = useAccess();

  const tagMenu = useMemo(() => {
    if (!tags) return <></>;
    return (
      <Menu>
        {tags.map((t) => (
          <Menu.Item key={t}>
            <Tag color="magenta">{t}</Tag>
          </Menu.Item>
        ))}
      </Menu>
    );
  }, [tags]);

  return (
    <Dropdown overlay={tagMenu}>
      <Badge count={tags?.length ?? 0} color="magenta">
        <Button
          size="small"
          onClick={() => {
            if (access.productQAEdit && permit) {
              handleTag({ from: id, currentTags: tags || [] });
            } else {
              message.warning('您没有权限设置标签');
            }
          }}
        >
          <Space>
            设置标签
            <DownOutlined />
          </Space>
        </Button>
      </Badge>
    </Dropdown>
  );
};

export type PgTagItem = { from: number; currentTags: string[] };

export const TagComponent: React.FC<{
  value: string | number;
  color?: string;
}> = ({ value, color = 'orange' }) => {
  return value ? <Tag color={color}>{value}</Tag> : <></>;
};
